import { useState } from "react";

import Button from "../../ui/buttons/Button";
import BaseInput from "../../ui/inputs/BaseInput/BaseInput";
import ModalOverlay from "../../ui/Modals/ModalOverlay";
import { extractApiErrorMessage } from "../../utils/apiError";
import { ConfirmDeleteModal } from "../database/ContactConfirmModals";

import styles from "./WhatsAppTemplates.module.css";

export const NEW_GROUP_TITLE = "Nuevo grupo";
export const EDIT_GROUP_TITLE = "Editar grupo";
export const GROUP_NAME_PLACEHOLDER = "Nombre del grupo";
export const GROUP_HINT =
  "Los grupos son de MaqMailing, para ordenar las plantillas; en WhatsApp no existen.";
export const DELETE_GROUP_LABEL = "Borrar grupo";
export const GROUP_ERROR_MESSAGE = "No se pudo guardar el grupo.";
export const DELETE_GROUP_ERROR_MESSAGE = "No se pudo borrar el grupo.";

const stopPropagation = (event) => event.stopPropagation();

const WhatsAppTemplateGroupModal = ({ group = null, onClose, onSave, onDelete, busy = false }) => {
  const [name, setName] = useState(group?.name ?? "");
  const [error, setError] = useState(null);
  const [confirmingDelete, setConfirmingDelete] = useState(false);
  const editing = Boolean(group);
  const canSave = Boolean(name.trim()) && (!editing || name.trim() !== group.name);

  const save = async () => {
    if (!canSave || busy) return;
    try {
      await onSave(name.trim());
    } catch (requestError) {
      setError(extractApiErrorMessage(requestError) || GROUP_ERROR_MESSAGE);
    }
  };

  const remove = async () => {
    try {
      await onDelete(group);
    } catch (requestError) {
      setConfirmingDelete(false);
      setError(extractApiErrorMessage(requestError) || DELETE_GROUP_ERROR_MESSAGE);
    }
  };

  return (
    <ModalOverlay className={styles.centeredOverlay} onClose={onClose}>
      <div
        className={styles.groupsModal}
        role="dialog"
        aria-label={editing ? EDIT_GROUP_TITLE : NEW_GROUP_TITLE}
        onClick={stopPropagation}
      >
        <h3 className={styles.groupsTitle}>{editing ? EDIT_GROUP_TITLE : NEW_GROUP_TITLE}</h3>
        <p className={styles.hint}>{GROUP_HINT}</p>

        <form
          className={styles.groupList}
          onSubmit={(event) => {
            event.preventDefault();
            save();
          }}
        >
          <BaseInput
            placeholder={GROUP_NAME_PLACEHOLDER}
            value={name}
            onChange={(value) => {
              setName(value);
              setError(null);
            }}
            error={error}
          />
          <div className={styles.groupModalActions}>
            {editing && (
              <button
                type="button"
                className={styles.linkButton}
                onClick={() => setConfirmingDelete(true)}
                disabled={busy}
              >
                {DELETE_GROUP_LABEL}
              </button>
            )}
            <div className={styles.formActions}>
              <Button variant="secondary" tone="blue" height={40} onClick={onClose} disabled={busy}>
                Cancelar
              </Button>
              <Button type="submit" tone="blue" height={40} disabled={!canSave} loading={busy}>
                Guardar
              </Button>
            </div>
          </div>
        </form>
      </div>

      {confirmingDelete && (
        <ConfirmDeleteModal
          name={group.name}
          title="¿Borrar el grupo?"
          description={
            <>
              Las plantillas de <strong>{group.name}</strong> quedan sin agrupar; no se borra ninguna plantilla.
            </>
          }
          deleting={busy}
          onCancel={() => setConfirmingDelete(false)}
          onConfirm={remove}
        />
      )}
    </ModalOverlay>
  );
};

export default WhatsAppTemplateGroupModal;
